var _style, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250.1 108.1",
    style: {
      enableBackground: "new 0 0 250.1 108.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#006937;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;}\n\t.st3{fill:#131313;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#A09958;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PMS_349"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.7,
    y: 37,
    className: "st1",
    width: 67.4,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "238.9,32.4 206.5,32.4 180.8,0 95.8,0 66.3,16.5 71.1,25.2 98.4,10 175.9,10 201.7,42.4 234,42.4  240.1,50.3 240.1,82.3 236.2,86.5 222.6,86.5 222.6,96.5 240.7,96.5 250.1,86.2 250.1,46.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.6,
    y: 55.5,
    className: "st1",
    width: 50.2,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.3,65.7c-6.9,0-12.8,4.5-15.9,11.2h-73.1c-3-6.7-9-11.2-15.9-11.2s-12.8,4.5-15.9,11.2H44.2L59,62.1H0v10 h34.8L30,76.9h-0.3v0.3l-0.2,0.2l0.2,0.2v19.2h44.9c3,6.6,9,11.2,15.9,11.2s12.8-4.5,15.9-11.2h73.1c3,6.6,9,11.2,15.9,11.2 c9.9,0,18-9.5,18-21.2C213.3,75.2,205.3,65.7,195.3,65.7z M90.5,98.1c-4.3,0-8-5.1-8-11.2s3.7-11.2,8-11.2s8,5.1,8,11.2 S94.8,98.1,90.5,98.1z M195.3,98.1c-4.3,0-8-5.1-8-11.2s3.7-11.2,8-11.2s8,5.1,8,11.2S199.7,98.1,195.3,98.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/Delivery.7320ee2f5f0da035a69ec686f2f70f69.svg";
export { ForwardRef as ReactComponent };